// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"440":"d9776b57","453":"49a6f9b4"}[chunkId] + ".chunk.js";
};